import { SCard } from 'components/shared/s-polaris';
import { classNames } from 'utils/class-names';

export const ShippingProviderCardSimplifiedShell: React.FC<ShippingProviderCardSimplifiedShellProps> = (props) => {
    const interactive = Boolean(props.onSelect) && !props.disabled;

    return (
        <SCard padding="none">
            <div
                onClick={interactive ? props.onSelect : undefined}
                className={classNames(
                    'p-2 flex flex-row gap-3 items-center border rounded-xl',
                    interactive && 'cursor-pointer hover-bg',
                    props.disabled && 'bg-bg-fill-disabled cursor-not-allowed',
                    props.selected ? 'border-black' : 'border-transparent'
                )}
            >
                {props.children}
            </div>
        </SCard>
    );
};

interface ShippingProviderCardSimplifiedShellProps {
    selected?: boolean;
    disabled?: boolean;
    onSelect?: () => void;
    children: React.ReactNode;
}
